module.exports = __webpack_public_path__ + "img/r-29.e8380a56.jpg";